import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

/* Image that drifts slower than the page (depth effect) and zooms subtly */
export function ParallaxImage({ src, alt = '', className = '', speed = 0.18, zoom = true, eager = false }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed * 100}%`, `${speed * 100}%`]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], zoom ? [1.25, 1.12, 1.25] : [1.2, 1.2, 1.2]);
  return (
    <div ref={ref} className={`parallax ${className}`}>
      <motion.img src={src} alt={alt} style={{ y, scale }} loading={eager ? 'eager' : 'lazy'} />
    </div>
  );
}

/* Moves any element vertically with scroll */
export function ParallaxY({ children, offset = 80, className, style }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], [offset, -offset]);
  return <motion.div ref={ref} className={className} style={{ ...style, y }}>{children}</motion.div>;
}
